import { z } from "zod";

import { httpHeaderFormSchema } from "./http-header-form-schema";

export const httpHeadersFormSchema = z.array(httpHeaderFormSchema).superRefine((headers, ctx) => {
	// Check for duplicate names and reserved header names
	const seenNames = new Set<string>();

	headers.forEach((header, index) => {
		if (seenNames.has(header.name)) {
			ctx.addIssue({
				code: "custom",
				message: "Name must be unique",
				path: [index, "name"],
			});
		}
		seenNames.add(header.name);

		if (header.name.toLowerCase() === "authorization") {
			ctx.addIssue({
				code: "custom",
				message: "Cannot use Authorization as a custom header",
				path: [index, "name"],
			});
		}
	});
});

export type HttpHeadersForm = z.infer<typeof httpHeadersFormSchema>;
